import { RootState } from 'types/state'
import { settingsSelectors } from 'store/settings'

// The runtime inputs the host injected, narrowed to what the agents declared.
// Re-sent on every agent call (answer + confirm) so secrets are never persisted server-side.
export const buildAgentInputs = (state: RootState): Record<string, unknown> => {
  const requirements = settingsSelectors.agentInputRequirements(state)
  const all = settingsSelectors.agentInputs(state)
  // The requirements come from GET /chats/:id/agents/params, which needs a chat: on the first
  // message of a brand-new chat there is none yet, so narrowing here would drop everything the
  // host injected (the agent then gets no journeyId/quoteId at all). Nothing to narrow by:
  // forward the lot, the server ignores what its tools do not bind.
  if (requirements.length === 0) return all
  return requirements.reduce<Record<string, unknown>>((acc, { key }) => {
    if (all[key] !== undefined) acc[key] = all[key]
    return acc
  }, {})
}
